// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__37nZE","ranges":"BmiRanges_ranges__3WAKT"};